"use strict";
exports.__esModule = true;
var client_1 = require("@apollo/client");
var cache = new client_1.InMemoryCache();
exports["default"] = cache;
